import config from './config'
import {Toast} from 'mint-ui'
export default {
    $ajax(opts, succ){
        //var vuex = JSON.parse(localStorage.vuex);
        var uuid = localStorage.A_uuid,
            token = localStorage.A_token;

        opts.type = 'post';
        opts.data = opts.data || {};
        opts.data.uuid = uuid;
        opts.data.token = token;
        opts = Object.assign(opts, {xhrFields: {withCredentials: true}});
        opts.url = config.apiHost+opts.url;
        return $.ajax(opts)
          .then(function(response) {
            // 拦截认证失败的情况
            if (response.code == 10001 || response.code == 10001) {
              localStorage.removeItem('A_uuid');
              localStorage.removeItem('A_token');
              window.location.href = '#/land';
            }
            // 正常情况返回数据
            return response;
          })
          .fail(()=>{
            Toast('network error')
        })
    }
}



// WEBPACK FOOTER //
// ./src/utils.js